"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Gets the route prefixed with the current locale
 * @param {string} language
 * @param {string} path
 */
function getLocaleRoute(language, path) {
  return "/".concat(language, "/").concat(path);
}
var _default = exports["default"] = getLocaleRoute;